import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { Angular2TokenService } from 'angular2-token';
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Enrolment } from "@models/enrolment";
import { Observable } from 'rxjs';
import { ActionCableService } from "./action-cable";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

export interface FetchEnrolmentsParams {
  class_ids?: number[],
  term_id?: number,
  student_id?: number,
  is_pending?: boolean,
  is_cancelling?: boolean,
  for_rollover_view?: boolean,
}

export interface SetRolloverParams {
  enrolment_id: number,
  target_action?: string | number, // Takes the form of "none" or a MatrixClass id.
}

export interface ChangeClassParams {
  enrolment_id: number,
  matrix_class_id: number,
}

export interface DisenrolmentParams {
  enrolment_id: number,
  refund_amount: number,
  reason: string,
}

@Injectable()
export class EnrolmentService {

  private enrolmentsUrl: string = 'enrolments'

  constructor(
    private http: Angular2TokenService,
    private actionCableService: ActionCableService,
    private store: Store<AppState>,
  ) {}

  fetchEnrolments(params: FetchEnrolmentsParams): Observable<Enrolment[]> {
    const searchParams: URLSearchParams = new URLSearchParams()
    const options: any = { search: searchParams }

    for (let key in params) { searchParams.set(key, params[key]) }
    return this.http.get(this.enrolmentsUrl, options)
      .map((res: Response): Enrolment[] => {
        return res.json().map((e: any) => Enrolment.clone(e))
      })
      .catch((error: Response) => Observable.throw(error.json()))
  }

  createEnrolment(params: any): Observable<Enrolment> {
    return this.http.post(this.enrolmentsUrl, params)
      .map((res: Response) => Enrolment.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  setRollover(params: SetRolloverParams): Observable<boolean> {
    return this.http.patch(
        `${this.enrolmentsUrl}/${params.enrolment_id}/set_rollover`,
        { target_action: params.target_action }
      )
      .mapTo(true)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  rolloverEnrolments(): Observable<boolean> {
    return this.http.patch(`${this.enrolmentsUrl}/rollover`, {})
      .mapTo(true)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  changeClass(params: ChangeClassParams): Observable<Enrolment> {
    return this.http.patch(`${this.enrolmentsUrl}/${params.enrolment_id}/change_class`, { matrix_class_id: params.matrix_class_id })
      .map((res: Response) => Enrolment.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  disenrol(params: DisenrolmentParams): Observable<Enrolment> {
    return this.http.patch(`${this.enrolmentsUrl}/${params.enrolment_id}/disenrol`, { refund_amount: params.refund_amount })
      .map((res: Response) => Enrolment.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/enrolment.ts